
import React from "react";

import '../styles.scss';
import './section3.scss';



/**
 * Section 3
 * h2 scientific text
 * flip card
 * 
 */


const Section3: React.FC = () => {
    return (<>
        <section className="container pt-2 pb-5 padBox bg-light">
            <h2 className="mb-5">Scientific Studies</h2>

            <div className="pp_mid_bar mt-3">
                <div className="pp_holder">
                    <div className="flip-card">
                        <div className="flip-card-inner">
                            <div className="flip-card-front">
                                <img src="assets/images/flip_images/D_Std_1.jpg" data-src="./assets/images/flip_images/D_Std_1.jpg" className="lazyloaded" />
                            </div>
                            <div className="flip-card-back">
                            <a className="flip_click_full" href="https://pubmed.ncbi.nlm.nih.gov/20691523/" target="_blank" />
                                <div className="flip_backbar">
                                    <a className="flip_click_a" href="https://pubmed.ncbi.nlm.nih.gov/20691523/" target="_blank"><span>CLICK </span><span style={{ textDecoration: "underline" }}>HERE</span><span style={{ textDecoration: "none" }}> for more</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="pp_holder">
                    <div className="flip-card">
                        <div className="flip-card-inner">
                            <div className="flip-card-front">
                                <img src="assets/images/flip_images/D_Std_2.jpg" data-src="./assets/images/flip_images/D_Std_2.jpg" className="lazyloaded" />
                            </div>
                            <div className="flip-card-back">
                            <a className="flip_click_full" href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6137615/"  target="_blank"/>
                                <div className="flip_backbar">
                                    <a className="flip_click_a" href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6137615/" target="_blank"><span>CLICK </span><span style={{ textDecoration: "underline" }}>HERE</span><span style={{ textDecoration: "none" }}> for more</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pp_holder">
                    <div className="flip-card">
                        <div className="flip-card-inner">
                            <div className="flip-card-front">
                                <img src="assets/images/flip_images/D_Std_3.jpg" data-src="./assets/images/flip_images/D_Std_3.jpg" className="lazyloaded" />
                            </div>
                            <div className="flip-card-back">
                                <a className="flip_click_full" href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8742249/" target="_blank"/>
                                <div className="flip_backbar">
                                    <a className="flip_click_a" href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8742249/" target="_blank"><span>CLICK </span><span style={{ textDecoration: "underline" }}>HERE</span><span style={{ textDecoration: "none" }}> for more</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>








            </div>

            <div className="clearfix mb-3"></div>

        </section>
    </>)
}

export default Section3;

